/**
 * Page inconnue (404) — lot NAV 0.5.x (A2 § 2.2, constat 12).
 *
 * Une route inconnue n'appartient à aucun niveau : la coquille gardait le DERNIER niveau mémorisé,
 * et la page « Page introuvable » affichait le menu du niveau Programme — c'est par là seulement
 * que le super-administrateur avait atteint ce niveau. L'écran 404 le signale à la coquille, qui
 * revient au niveau par défaut (Projet si un espace est ouvert, Organisation sinon) tant qu'il est
 * affiché ; la mémoire du niveau n'est pas modifiée.
 */
import { createContext, useContext, useEffect, type ReactNode, type JSX } from 'react'

const Ctx = createContext<((inconnue: boolean) => void) | null>(null)

export function FournisseurPageInconnue({ signaler, children }: {
  signaler: (inconnue: boolean) => void
  children: ReactNode
}): JSX.Element {
  return <Ctx.Provider value={signaler}>{children}</Ctx.Provider>
}

/** Appelé par l'écran 404 : vrai tant qu'il est monté. Sans coquille (tests), ne fait rien. */
export function useSignalerPageInconnue(): void {
  const signaler = useContext(Ctx)
  useEffect(() => {
    if (!signaler) return undefined
    signaler(true)
    return () => signaler(false)
  }, [signaler])
}
